/**
 * Sanctum preview (brief §8, §10): a static screen mapping the Starter
 * Axie's six part slots to the game verb each one owns. Round 1 has no
 * swappable parts - the Axie itself never changes - so this is read-only:
 * it exists to make the Axie Core mapping legible to a judge, not to let
 * the player pick anything. Round 2's live Mixer version replaces this
 * component behind the same call site.
 */
const SLOTS: ReadonlyArray<{ slot: string; verb: string; starter: string }> = [
  { slot: 'Horn', verb: 'The shape of cast', starter: 'One block, facing tile' },
  { slot: 'Back', verb: 'Mobility', starter: 'Single jump' },
  { slot: 'Mouth', verb: 'Consume / touch', starter: '—' },
  { slot: 'Tail', verb: 'The ranged verb', starter: 'Locked (Charm only)' },
  { slot: 'Eyes', verb: 'Information', starter: '—' },
  { slot: 'Ears', verb: 'Information', starter: '—' },
  { slot: 'Class', verb: 'Passive affinity', starter: 'Plant' },
];

export function Sanctum({
  brambleHornUnlocked,
  onClose,
}: {
  /** Whether Room 5 has been cleared (brief §7: the Round 1 Horn unlock). */
  brambleHornUnlocked: boolean;
  onClose: () => void;
}) {
  return (
    <div className="overlay sanctum">
      <p>Sanctum</p>
      <p className="overlay-sub">Each Axie part owns one verb — this Starter has all six, unswapped</p>
      <table className="sanctum-table">
        <thead>
          <tr>
            <th>Part</th>
            <th>Owns</th>
            <th>Starter</th>
          </tr>
        </thead>
        <tbody>
          {SLOTS.map((row) => (
            <tr key={row.slot}>
              <td>{row.slot}</td>
              <td>{row.verb}</td>
              <td>{row.slot === 'Tail' && brambleHornUnlocked ? 'Fireball active (Bramble Horn)' : row.starter}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="overlay-sub">
        {brambleHornUnlocked
          ? 'Bramble Horn unlocked — the Tail fireball now fires with no Charm needed.'
          : 'Clear Patrol (Room 5) to unlock the Bramble Horn.'}
      </p>
      <p className="overlay-sub">
        Round 1&apos;s Horn unlock grants the Tail&apos;s verb rather than changing cast&apos;s
        shape — a deliberate deviation from the mapping above, made so the fireball has a
        real way to fire without an item Round 1 never authors into any room.
      </p>
      <div className="overlay-actions">
        <button type="button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
